<template>
  <section class="buwebshop">
    <customWebshop v-if="surrounding.id === 1970" :webshopId="item.itemable.id" :surrounding="surrounding"/>
    <div v-else id="enjoj-webshop" :webshop-id="item.itemable.id" :theme-color="surrounding.style" :header-height="headerHeight"></div>
  </section>
</template>

<script>
import customWebshop from './CustomWebshop.vue'
import buildWebshop from 'ec-webshop-pwa'

export default {
  name: 'ec-business-webshop',
  components: {
    customWebshop
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: 'Dit is het ec-business-webshop component.',
      themeColor: '#FFD000',
      headerHeight: '0,0',
      scripts: [],
      styles: []
    }
  },
  mounted () {
    if (this.surrounding.id !== 1970) buildWebshop()
  }
}
</script>
